const { useDisclosure, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter } = require("@chakra-ui/react")

export default function CommonModal({reset, title=null, desc=null, setTargetDeleteId, setTargetDeleteApplyId = (id) => {}, deleteAction, targetDeleteId, targetDeleteApplyId = null, reFilterUsers = (targetDeleteId) => {}}) {
    const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: true });

    const handleClose = () => {
        reset(false);
        onClose();
    }

    const handleDelete = () => {
        deleteAction(targetDeleteId, targetDeleteApplyId);
        reFilterUsers(targetDeleteId);
        setTargetDeleteId(null);
        setTargetDeleteApplyId(null);
        
        handleClose();
    }

    return (
        <>
            <Modal isOpen={isOpen} onClose={handleClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        {title
                            ? title
                            : 'Confirm Delete'
                        }
                    </ModalHeader>
                    <ModalCloseButton />

                    <ModalBody>
                        {desc
                            ? desc
                            : 'Are you sure to delete this?'
                        }
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='gray' mr={3} onClick={handleClose}>
                            Close
                        </Button>
                        <Button colorScheme='red' onClick={handleDelete}>Delete</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}
